import type { JSX, ReactNode } from "react";

interface PageHeaderProps {
  breadcrumb?: ReactNode;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ breadcrumb, title, subtitle, actions }: PageHeaderProps): JSX.Element {
  return (
    <header className="mb-5" data-testid="page-header">
      {breadcrumb && (
        <div
          className="mb-1 flex items-center gap-1.5 text-[12.5px] font-semibold text-[var(--text-subtle)]"
          data-testid="page-header-breadcrumb"
        >
          {breadcrumb}
        </div>
      )}
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1
            className="text-[27px] font-extrabold tracking-tight text-[var(--text-primary)]"
            data-testid="page-header-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p
              className="mt-1 text-sm text-[var(--text-secondary)]"
              data-testid="page-header-subtitle"
            >
              {subtitle}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 items-center gap-2" data-testid="page-header-actions">
            {actions}
          </div>
        )}
      </div>
    </header>
  );
}
